/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/StarCountDisplay',['pixi', 'absolute', 'lodash'],

	function (PIXI, Absolute, _) {

		var StarCountDisplay = function (options, parent, game) {
			this.game = game;
			this._initStarCountDisplay(options, parent);
		};

		StarCountDisplay.constructor = StarCountDisplay;
		StarCountDisplay.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

		StarCountDisplay.prototype._initStarCountDisplay = function (options, parent) {

			PIXI.DisplayObjectContainer.call(this);

			var defaultOptions = {
				letterStyle: {
					font: Absolute.ScreenMetrics.getResScale() * 32 + 'px Arial',
					fontFamily: 'segoe',
					fill: '#fff12f',
					tint: 0xfff12f,
					align: 'left'
				},
				width: Absolute.Coords.x(150),
				height: Absolute.Coords.x(66)
			};

			var frameName = (this.game.config.singleGame.enabled) ? 'freecell/tile.png' : 'star_club/star_topbar_balance.png';
			this.starIcon = PIXI.Sprite.fromFrame(frameName);

			this.options = _.extend(defaultOptions, options);
			this.parent = parent;

			if (!this.options.hideBackground) {
				this.addBackground();
			}


			this.starIcon.x = Absolute.Coords.x(20);
			this.starIcon.y = Absolute.Coords.y(15);
			this.addChild(this.starIcon);

			this.starCount = new PIXI.Text('...', this.options.letterStyle);
			this.starCount.x = Absolute.Coords.y(62);
			this.starCount.y = Absolute.Coords.y(15);
			this.addChild(this.starCount);

			this.starClips = [];
			this.tweens = [];

			this.oldStars = this.stars = 0;
			this.hoverGraphic = new PIXI.Graphics();
			var lineWeight = Absolute.Coords.x(2);
			this.hoverGraphic.beginFill(0xFFFFFF, 0);
			this.hoverGraphic.lineStyle(lineWeight, 0xFFFFFF, 1);
			this.hoverGraphic.drawRect(0, 0, this.width, this.height);
			this.hoverGraphic.endFill();
			this.hover = this.hoverGraphic;
			this.hover.alpha = 1;
			this.hover.visible = false;
			this.addChild(this.hover);

		};

		StarCountDisplay.prototype.addBackground = function () {

			var background = new PIXI.Graphics(),
				stroke = new PIXI.Graphics(),
				strokeWeight = Math.ceil(Absolute.Coords.x(1));

			background.beginFill(0x000001, 0.3);
			background.drawRect(0, 0, this.options.width, this.options.height);
			background.endFill();

			stroke.lineStyle(strokeWeight, 0xffffff, 0.5);
			stroke.beginFill(0xffffff, 0);
			stroke.drawRect(0, 0, this.options.width - strokeWeight * 4, this.options.height - strokeWeight * 4);
			stroke.endFill();
			stroke.x = strokeWeight * 2;
			stroke.y = strokeWeight * 2;
			background.hoverBox = this.options.hoverBox;

			this.addChild(background);
			this.addChild(stroke);
		};

		StarCountDisplay.prototype.onShow = function (starCount, forceUpdate) {

			this.oldStars = this.stars;
			this.stars = starCount;
			if (forceUpdate) {
				this.starCount.setText(starCount.toString());
				//this.starCount.setText('999999');
			}

		};

		StarCountDisplay.prototype.onHide = function () {
			_.each(this.tweens, function (tween) {
				tween.stop();
			});
			this.tweens.length = 0;
			TWEEN.removeAll();

			_.each(this.starClips, function (clip) {
				clip.visible = false;
			}, this);

			if (this.starBurstClip) {
				this.starBurstClip.stop();
				this.starBurstClip.visible = false;
			}
			this.onShow(this.stars, true);
		};

		StarCountDisplay.prototype.triggerStarAnimation = function (challengeTile, reverse, callback) {

			reverse = !!reverse;

			if (this.starClips.length === 0) {

				_.times(8, function () {
					var clip = Absolute.SpriteUtils.loadMovieClip('star_club/stars-rotating/star-rotating_', 9, 1);
					clip.anchor.x = clip.anchor.y = 0.5;
					//clip.pivot.x = clip.width / 2;
					//clip.pivot.y = clip.height / 2;
					clip.animationSpeed = 0.5;
					this.starClips.push(clip);
					this.parent.addChild(clip);
				}, this);

				this.starBurstClip = Absolute.SpriteUtils.loadMovieClip('star_club/stars-bursting/star-bursting-187x170_', 30, 1);
				this.starBurstClip.anchor.x = this.starBurstClip.anchor.y = 0.5;
				this.starBurstClip.x = this.x + Absolute.Coords.x(50);
				this.starBurstClip.y = this.y + Absolute.Coords.y(50);
				this.starBurstClip.loop = false;
				this.starBurstClip.animationSpeed = 0.5;
				this.parent.addChild(this.starBurstClip);
			}

			var starCompleteCount = 0,
				self = this,
				countTween = new TWEEN.Tween({s: this.oldStars})
					.easing(TWEEN.Easing.Cubic.Out)
					.to({s: this.stars}, 1500)
					.onStart(function () {
						Absolute.AudioManager.playSound('sc_starLand');
					})
					.onUpdate(function () {
						self.starCount.setText(Math.round(this.s).toString());
					});

			this.tweens.push(countTween);

			_.each(this.starClips, function (clip, index) {

				var startX = challengeTile.worldTransform.tx + challengeTile.width / 2,
					startY = challengeTile.worldTransform.ty + challengeTile.height / 2,
					endX = this.x + Absolute.Coords.x(50),
					endY2 = this.y + Absolute.Coords.y(50),
					endY1 = endY2 * 1.2;

				if (reverse) {
					var tmp1 = startX, tmp2 = startY;
					startX = endX;
					startY = endY2;
					endX = tmp1;
					endY2 = tmp2;
				}

				clip.scale.x = clip.scale.y = 0;
				clip.x = startX;
				clip.y = startY;
				clip.visible = true;

				var starTween = new TWEEN.Tween({scale: 0, x: startX, y: startY})
					.delay(100 * index)
					.easing(TWEEN.Easing.Quadratic.Out)
					.to({scale: [1.5, 0.2], x: endX, y: [endY1, endY2]}, 1800)
					.onStart(function () {
						clip.gotoAndPlay(0);
					})
					.onUpdate(function () {
						clip.scale.x = clip.scale.y = this.scale;
						clip.x = this.x;
						clip.y = this.y;
					})
					.onComplete(function () {
						starCompleteCount++;
						clip.scale.x = clip.scale.y = 0;
						if (starCompleteCount === 1 && !reverse) {
							self.starBurstClip.visible = true;
							self.starBurstClip.gotoAndPlay(0);
							countTween.start();
						}
						if (starCompleteCount === 1 && callback) {
							callback();
						}
					})
					.interpolation(TWEEN.Interpolation.Bezier)
					.start();

				this.tweens.push(starTween);

			}, this);

		};

		StarCountDisplay.prototype.handleActivate = function () {
		};

		StarCountDisplay.prototype._focusChanged = function () {
			this.hover.visible = this._hasFocus;
		};

		Object.defineProperty(StarCountDisplay.prototype, "focus", {
			get: function () {
				return this._hasFocus;
			},
			set: function (value) {
				this._hasFocus = value;
				this._focusChanged();
				return value;
			}
		});

		return StarCountDisplay;

	});

